export default __webpack_public_path__ + "static/media/app_apple.ca990794.svg";